import xlsx, { BookType } from 'xlsx'

export function exportToExcel(
  data: unknown[],
  fileName: string,
  bookType: BookType,
) {
  const book = xlsx.utils.book_new()

  xlsx.utils.book_append_sheet(book, xlsx.utils.json_to_sheet(data))
  xlsx.writeFile(book, `${fileName}.${bookType}`, { bookType })
}
